import React from "react";

export default function Policies() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="font-display font-bold text-3xl text-slate-900 mb-6">Privacy Policy</h1>
      <div className="prose prose-slate max-w-none space-y-4 text-slate-600">
        <p>
          HealthConnect is committed to protecting your personal and health information. This policy
          outlines how we collect, use, and safeguard your data.
        </p>
        <h2 className="font-display font-semibold text-xl text-slate-800">1. Data We Collect</h2>
        <p>
          We collect personal information such as name, email, phone number, and health-related
          details necessary to provide our services.
        </p>
        <h2 className="font-display font-semibold text-xl text-slate-800">2. How We Use It</h2>
        <p>
          Your data is used to facilitate doctor appointments, lab bookings, payments, and
          notifications. We never sell your data to third parties.
        </p>
        <h2 className="font-display font-semibold text-xl text-slate-800">3. Data Security</h2>
        <p>
          We use industry-standard encryption and security practices to keep your data safe.
        </p>
        <p className="text-sm text-slate-400 mt-8">Last updated: January 2025</p>
      </div>
    </div>
  );
}
